import { render, staticRenderFns } from "./pcDetails.vue?vue&type=template&id=0a432d53&scoped=true&"
import script from "./pcDetails.vue?vue&type=script&lang=js&"
export * from "./pcDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a432d53",
  null
  
)

export default component.exports